





import '@/styles/simple-reset.css'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class App extends Vue {
  errorCaptured(error: Error) {
    console.log(error)
  }
}
